import { render, staticRenderFns } from "./Grades.vue?vue&type=template&id=50a2ad31&"
import script from "./Grades.vue?vue&type=script&lang=js&"
export * from "./Grades.vue?vue&type=script&lang=js&"
import style0 from "./Grades.vue?vue&type=style&index=0&id=50a2ad31&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports